/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HeoTransactionNumber
 */
export interface HeoTransactionNumber {
    /**
     * 
     * @type {string}
     * @memberof HeoTransactionNumber
     */
    companyCode: string;
    /**
     * 
     * @type {number}
     * @memberof HeoTransactionNumber
     */
    number: number;
}

/**
 * Check if a given object implements the HeoTransactionNumber interface.
 */
export function instanceOfHeoTransactionNumber(value: object): value is HeoTransactionNumber {
    if (!('companyCode' in value) || value['companyCode'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function HeoTransactionNumberFromJSON(json: any): HeoTransactionNumber {
    return HeoTransactionNumberFromJSONTyped(json, false);
}

export function HeoTransactionNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeoTransactionNumber {
    if (json == null) {
        return json;
    }
    return {
        
        'companyCode': json['companyCode'],
        'number': json['number'],
    };
}

export function HeoTransactionNumberToJSON(json: any): HeoTransactionNumber {
    return HeoTransactionNumberToJSONTyped(json, false);
}

export function HeoTransactionNumberToJSONTyped(value?: HeoTransactionNumber | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyCode': value['companyCode'],
        'number': value['number'],
    };
}

